import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Chemistry from '../../../images/chemistry_icon.png';
import Zoology from '../../../images/zoology_icon.png';
import Physics from '../../../images/physics_icon.png';
import Maths from '../../../images/maths_icon.png';
import Botany from '../../../images/botany_icon.png';
import '../../components/eamcet_practise_test/_eamcetPratiseTest.scss';
import { isMobile } from "react-device-detect";


const SUBJECT_STYLES = {
    Botany: "botany",
    Physics: "physics",
    Chemistry: "chemistry",
    Zoology: "zoology",
    Mathematics: "maths",
    Biology: "botany"
};

const SUBJECT_IMAGES = {
    "1": Botany,
    "2": Physics,
    "3": Chemistry,
    "4": Maths,
    "5": Zoology,
    "6": Botany
};

const SUBJECT_MAP = {
    "1": "Botany",
    "2": "Physics",
    "3": "Chemistry",
    "4": "Mathematics",
    "5": "Zoology",
    "6": "Biology"
};

const CLASS_MAP = {
    "1": "XI",
    "2": "XII"
};

class ChapterWisePractiseSessionSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            getSubjectsArr: [],
            selectedSubjectVal: "",
            classValue: "1",
            searchChapter: "",
        };

        this.isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid") || "null");
    }


    componentDidMount() {
        const { getSubjectOrder } = this.props;

        if (Array.isArray(getSubjectOrder) && getSubjectOrder.length > 0) {
            const subjects = getSubjectOrder.map((item, index) => ({
                ...item,
                active: index === 0 ? "active" : "",
            }));

            this.setState({
                getSubjectsArr: subjects,
                selectedSubjectVal: subjects[0].id
            });
        }
    }


    subjectClassName = (data) =>
        `block_white ${SUBJECT_STYLES[data.subject] || ""} mobile_card_eamcet ${data.active}`;

    handleSelect = (subid) => {
        const updatedSubjects = this.state.getSubjectsArr.map(item => ({
            ...item,
            active: item.id === subid ? "active" : ""
        }));

        this.setState({
            getSubjectsArr: updatedSubjects,
            selectedSubjectVal: subid,
            searchChapter: "",
            classValue: "1",
        });
    };

    handleSelectClassVal = (val) => {
        this.setState({
            classValue: val,
            searchChapter: "",
        });
    };

    practiseChapters = (valid) => {
        const { selectedSubjectVal } = this.state;
        if (valid.chapter_id !== undefined) {
            localStorage.setItem("subjectid", +selectedSubjectVal);
            localStorage.setItem("type", "practice");
            localStorage.setItem("ocid", valid.chapter_id);
            localStorage.setItem("otid", "0");
            localStorage.setItem("practice_type", 3);
            window.open("/student/subject/practice-test", "_blank") //to open new page
        }
    }

    handleChange = (event) => {
        let newValue = event.target.value;
        newValue = newValue.replace(/^\s+/, '');
        newValue = newValue.substring(0, 30);

        this.setState({ searchChapter: newValue });
    }

    render() {

        const { getSubjectsArr, classValue, selectedSubjectVal, searchChapter } = this.state;

        const subjectWiseChapters = this.props.getPracticeChapterNames
            ?.find(item => +item.id === +selectedSubjectVal);

        const filteredChapters = subjectWiseChapters?.practice_chapters
            ?.filter(item =>
                +item.class_id === +classValue &&
                item.chapter_name.toLowerCase().includes(searchChapter.toLowerCase())
            ) || [];


        return (
            <Container className={`eamcet-practise-test ${isMobile ? 'mt-5' : 'mt-2'}`}>

                <style>
                    {`
                        .hoverCard {
                                padding: 20px;
                                border: 1px solid rgba(33, 48, 70, 0.2);
                                border-radius: 8px;
                                cursor: pointer;
                                transition: all 0.3s ease-in-out;
                            }
                        .hoverCard:hover { 
                                background-color: #f2f0ff;
                                box-shadow: 0px 5px 15px rgba(0,0,0,0.15);
                                transform: translateY(-3px);
                            }
                    `}
                </style>

                {/* Subject Selection */}
                <Row>
                    <Col sm={12}>
                        <div className="subject-blocks-view">
                            {getSubjectsArr.map(sub => (
                                <div
                                    key={sub.id}
                                    className={this.subjectClassName(sub)}
                                    onClick={() => this.handleSelect(sub.id)}
                                >
                                    <Row>
                                        <Col sm={8}>
                                            <h5 className='mt-2'>{sub.subject}</h5>
                                        </Col>
                                        <Col sm={4}>
                                            <Card.Img
                                                variant="top"
                                                src={SUBJECT_IMAGES[sub.id]}
                                                className="mobile_sub_img"
                                                alt={sub.subject}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>

                {/* Class Selection */}
                <Row className='d-flex justify-content-between'>
                    <Col sm={8}>
                        <ul className='list-inline class_type_li mt-4'>
                            {["1", "2"].map(id => (
                                <li
                                    key={id}
                                    className={`${this.state.classValue === id ? "active" : ""} ${id === "2" ? "ml-4" : ""}`}
                                    onClick={() => this.handleSelectClassVal(id)}
                                >
                                    Class {CLASS_MAP[id]}
                                </li>
                            ))}
                        </ul>
                    </Col>

                    <Col sm={4} className='d-flex justify-content-end'>
                        <ul className='list-inline class_type_li mt-4'>
                            <li className='active'>Exam History</li>
                        </ul>
                    </Col>
                </Row>

                {/* Header Title */}
                <Row className="align-items-center mt-2">
                    <Col sm={8}>
                        <h5 className="mb-2">
                            Chapter Wise Practise Sessions - ( Subject : {SUBJECT_MAP[selectedSubjectVal]},
                            Class : {CLASS_MAP[classValue]} )
                        </h5>
                    </Col>

                    <Col sm={4}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search Chapter..."
                            style={{
                                fontSize: "14px",
                                padding: "4px 8px",
                                borderRadius: "6px",
                                border: "1px solid #ccc"
                            }}
                            value={searchChapter}
                            onChange={this.handleChange}
                        />
                    </Col>

                    <Col sm={12}>
                        <hr />
                    </Col>
                </Row>

                {/* Chapterwise exams */}
                <Row>
                    {filteredChapters.length === 0 ? (
                        <Col sm={12}>
                            <div className='text-center h6 fw-bold text-uppercase'>No Data Found</div>
                        </Col>
                    ) : filteredChapters.map((item, index) => (
                        <Col sm={12} md={6} lg={4} key={item.chapter_id || index}>
                            <Card
                                className="p-3 mt-3 shadow hoverCard"
                                style={{
                                    borderRadius: "12px",
                                    cursor: "pointer",
                                    transition: "transform 0.2s ease-in-out"
                                }}
                            >
                                <h6 style={{ fontWeight: "700" }}>
                                    {item.chapter_name}
                                </h6>

                                <div style={{ textAlign: "right" }}>
                                    <button
                                        onClick={() => this.practiseChapters(item)}
                                        style={{
                                            background: "#0099ff",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "20px",
                                            padding: "6px 16px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            cursor: "pointer"
                                        }}
                                    >
                                        Start Test
                                    </button>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>

            </Container>
        );
    }
}
export default ChapterWisePractiseSessionSection;     